module.exports = __webpack_public_path__ + "img/illustration-home.72089375.svg";